module.exports = __webpack_public_path__ + "static/media/gcdef_10038.d826f961.ico";